<template>
  <button
    class="app-btn"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'AppButton',
};
</script>

<style lang="scss">
.app-btn {
  padding: .5rem .75rem;
  color: white;
  background-color: orange;
  border-radius: .5rem;

  @media (min-width: 960px) {
    padding: .5rem 1rem;
  }
}
</style>
